export interface ApiKey {
  id: string;
  name: string;
  key_prefix: string;
  scopes: string[];
  rate_limit_rpm: number;
  is_active: boolean;
  last_used_at: string | null;
  expires_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  revoked_at: string | null;
}

export interface ApiKeyCreateResponse {
  key: ApiKey;
  rawKey: string;
}

export interface AuditLogEntry {
  id: string;
  api_key_id: string | null;
  organisation_id: string;
  action: string;
  resource: string;
  request_body: Record<string, unknown> | null;
  response_status: number;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  key_name?: string;
}

export interface AuditLogResponse {
  entries: AuditLogEntry[];
  total: number;
  pageNumber: number;
  pageLength: number;
}

export interface ApiScope {
  value: string;
  label: string;
  description: string;
}

export const AVAILABLE_SCOPES: ApiScope[] = [
  { value: 'kpi:read', label: 'KPI Read', description: 'List KPI definitions and their codes' },
  { value: 'kpi:write', label: 'KPI Write', description: 'Push KPI values (upsert by code + date)' },
];
